import { render } from "./BaseTitle.vue?vue&type=template&id=0f850518&scoped=true"
import script from "./BaseTitle.vue?vue&type=script&lang=js"
export * from "./BaseTitle.vue?vue&type=script&lang=js"

import "./BaseTitle.vue?vue&type=style&index=0&id=0f850518&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f850518"]])

export default __exports__